import { NgModule, APP_INITIALIZER }           from '@angular/core';
import { CommonModule }       from '@angular/common';
import { FormsModule }        from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { TicketingComponent } from './ticketing.component';
import { TicketingListComponent } from './ticketing-list/ticketing-list.component';
import { TicketingFiltersComponent } from './ticketing-filtre/ticketing-filtre.component';

import { TListService } from './services/ticketing.service';
import { TicketingService } from '../services/ticketing-service/ticketing.service';

import { AngularMaterialModule } from '../angular-material.module';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  imports:      [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    TranslateModule
  ],
  declarations: [
    TicketingComponent,
    TicketingListComponent,
    TicketingFiltersComponent
  ],
  exports:      [
    TicketingComponent
  ],
  providers:    [ 
    TListService, 
    TicketingService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    } 
  ]
})
export class TicketingModule { }
